import React, { forwardRef, useEffect, useState } from 'react';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { useCardPageFilters } from '../../useCardPageFilters';

function FaceIdsFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const [error, setError] = useState<string>('');
  const { filters, updateFilters, updateFiltersDebounced } = useCardPageFilters();

  const onChangeHandler = (face_ids: string) => {
    setLocalValue(face_ids);

    const validationResult = validate.multipleUuid()(face_ids);
    if (typeof validationResult === 'string') {
      setError(validationResult);
      return;
    }

    setError('');
    updateFiltersDebounced({ face_ids: face_ids?.length > 0 ? face_ids : undefined });
  };

  useEffect(() => {
    setLocalValue(filters.face_ids ?? '');
  }, [filters.face_ids]);

  const reset = () => {
    updateFilters({ face_ids: undefined });
    setLocalValue('');
    setError('');
  };

  return (
    <PopoverWithButton
      {...props}
      onClickReset={reset}
      ref={ref}
      title={<div className="Body-2">{t('card-page:filters.popovers.face ids.label')}</div>}
    >
      <Control.Input
        errorMessage={error}
        onChangeValue={onChangeHandler}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const FaceIdsFilterPopoverWithRef = forwardRef(FaceIdsFilterPopover);
export { FaceIdsFilterPopoverWithRef as FaceIdsFilterPopover };
